import * as React from 'react'

export const DisplayMode = React.createContext('preview')
